import { render, staticRenderFns } from "./taxationFormList.vue?vue&type=template&id=62d0ce7c&scoped=true&"
import script from "./taxationFormList.vue?vue&type=script&lang=js&"
export * from "./taxationFormList.vue?vue&type=script&lang=js&"
import style0 from "./taxationFormList.vue?vue&type=style&index=0&id=62d0ce7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d0ce7c",
  null
  
)

export default component.exports